"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function zec(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M11.322 14.8845H16.0447V17.397H13.1385C13.1865 18.1155 13.2112 18.7823 13.2592 19.5H10.8135V17.4225H7.90646C7.90646 16.6027 7.80971 15.7823 7.95521 15.0128C8.02796 14.6025 8.46371 14.2432 8.72996 13.8848C9.65114 12.7336 10.5797 11.5883 11.5155 10.449C11.8792 10.0125 12.2422 9.60225 12.654 9.1155H8.12396V6.603H10.8135V4.5H13.1625V6.55125H16.0935C16.0935 7.39725 16.1902 8.21775 16.0447 8.98725C15.972 9.3975 15.5362 9.75675 15.246 10.1153C14.3248 11.2664 13.3963 12.4117 12.4605 13.551C12.0951 14.0074 11.7154 14.4521 11.322 14.8845Z", fill: color }));
}
exports["default"] = zec;
//# sourceMappingURL=zec.js.map